export default __webpack_public_path__ + "static/media/springboot.d333f33c.svg";